import type { LucideIcon } from 'lucide-react';

interface FeatureBenefitProps {
  icon: LucideIcon;
  title: string;
  description: string;
}

/**
 * Individual feature benefit item.
 * Clean Apple-style design - minimal, with subtle background.
 */
export function FeatureBenefit({ icon: Icon, title, description }: FeatureBenefitProps) {
  return (
    <div className="flex items-start gap-4 p-4 rounded bg-gray-50 dark:bg-gray-900/50">
      <div className="flex-shrink-0 w-10 h-10 rounded bg-white dark:bg-gray-800 flex items-center justify-center shadow-sm">
        <Icon className="w-5 h-5 text-gray-600 dark:text-gray-400" />
      </div>
      <div className="flex-1 min-w-0 pt-0.5">
        <h3 className="font-medium text-gray-900 dark:text-gray-100">{title}</h3>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400 leading-relaxed">{description}</p>
      </div>
    </div>
  );
}
